import { Provider } from '@vgtv/api-client';

type Language = 'nb' | 'sv' | 'en';

const localeByProvider: { [provider in Provider]: Language } = {
  [Provider.VGTV]: 'nb',
  [Provider.AB]: 'sv',
};

export interface CharacterMap {
  [char: string]: string;
}

/*
  Should match CAPIs transliteration of nb/sv
  @see https://github.schibsted.io/spt-mediaplatform/plan3-parent/blob/master/format/src/main/java/plan3/article/internal/util/Transliterations.java#L12
 */
const capiCharacterMaps: {
  [language in Language]: CharacterMap;
} = {
  en: {},
  nb: {
    æ: 'ae',
    ø: 'oe',
    å: 'aa',
  },
  sv: {
    ä: 'a',
    ö: 'o',
    å: 'a',
  },
};

function getCharacterMap(provider: Provider): CharacterMap {
  return capiCharacterMaps[localeByProvider[provider]] || {};
}

/**
 * Replace characters in string by map of characters
 */
function replaceCharacterMap(
  input: string,
  characterMap: CharacterMap
): string {
  return input
    .split('')
    .map((char) => characterMap[char] || char)
    .join('');
}

const WORD_DELIMITERS_REGEX = /[\s/]+/g;
const INVALID_URL_CHARACTERS_REGEX = /[^\w-]+|-$|^-|_/g;
const MULTI_DASH_CHARACTERS_REGEX = /-{2,}/g;
const EDGE_DASH_REGEX = /(?:^-+|-+$)/g;
/**
 * Normalizes the input string using canonical decomposition (NFD)
 * and replaces all word delimiters with dashes.
 */
export function getSlug(input = '', provider = Provider.VGTV) {
  return replaceCharacterMap(input.toLowerCase(), getCharacterMap(provider))
    .normalize('NFD')
    .replace(WORD_DELIMITERS_REGEX, '-')
    .replace(INVALID_URL_CHARACTERS_REGEX, '')
    .replace(MULTI_DASH_CHARACTERS_REGEX, '-')
    .replace(EDGE_DASH_REGEX, '');
}
